module.exports = __webpack_public_path__ + "img/check-white.96a2e54a.svg";